import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  iconInButton: {
    marginRight: theme.spacing(1),
  },
  myInstancesTextButton: {
    '&.MuiButton-root': {
      border: '1px solid transparent',
      boxShadow: 'none',
      color: `${theme.palette.secondary.main} !important`,
      fontWeight: 400,
      lineHeight: 1.75,
      minHeight: 28,
      outline: 'none',
      padding: theme.spacing(0.5, 1),
      textDecoration: 'none',
      transform: 'none',
      '&::before, &::after': {
        display: 'none',
      },
      '&:hover': {
        background: `${(theme.palette.secondary as unknown as Record<string, string>)[50]} !important`,
        border: '1px solid transparent',
        boxShadow: 'none',
        color: `${theme.palette.secondary.dark} !important`,
        fontWeight: 400,
        lineHeight: 1.75,
        minHeight: 28,
        outline: 'none',
        padding: theme.spacing(0.5, 1),
        textDecoration: 'none',
        transform: 'none',
      },
      '&:hover::before, &:hover::after': {
        display: 'none',
      },
      '&:focus': {
        outline: 'none',
      },
    },
  },
}));
